<!-- Finestra modale glossario -->

<template>
    <div class="modal fade" id="modalGlossary" tabindex="-1" role="dialog" aria-labelledby="modalGlossary" aria-hidden="true">
      <div class="modal-dialog" style="max-width:1300px;" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{title}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-html="text"></div>
          </div>            
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default({
    
    name: 'modalGlossary',

    props: ['title' , 'text'],

})
</script>
